module.exports = __webpack_public_path__ + "static/media/chevron-down-orange-2.ee6561b5.svg";